/**
 * 製法区分（入札会専用）
 */
export const ManufacturingMethodConst =
{
  /**
   * 普通蒸
   */
  NORMAL_STEAMED: 1,
  /**
   * 深蒸
   */
  DEEP_STEAMED: 2,
} as const;
export type ManufacturingMethodType = typeof ManufacturingMethodConst[keyof typeof ManufacturingMethodConst];

export const ManufacturingMethodOptions: { value: ManufacturingMethodType; label: string }[] = [
  { value: ManufacturingMethodConst.NORMAL_STEAMED, label: '普通蒸' },
  { value: ManufacturingMethodConst.DEEP_STEAMED, label: '深蒸' },
];
